import React, { createContext, useCallback, useEffect, useState } from 'react';
import ErrorPage from '../pages/ErrorPage';
import LoadingPage from '../pages/LoadingPage';
import ImageViewer from '../components/ImageViewer';
import Wrapper from '../components/Wrapper';
import { useSearchParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import TagManager from 'react-gtm-module';
import i18n from '../config/i18n';
import { useFlow } from './FlowContext';
import { STORE_ARRAYS } from './StoreList';


const doesStoreHasCouponlogic = (shopId) => {
  return STORE_ARRAYS.find(
    (store) => store.storeId === shopId && store.hadDiscount
  );
};

const GTM_IDS = [
  'GTM-PLBRD26'
];
const eventPages = {
  Landing_page_visit: {
    pageTitle: 'Registration Benefit',
    pagePath: '/ssr/benefit',
    pageCategory: 'Registration Benefit',
  },
  nav_to_coupon: {
    pageTitle: 'Coupon Page',
    pagePath: '/ssr/coupon',
    pageCategory: 'Coupon Page',
  },
  nav_to_old_device: {
    pageTitle: 'Old Device Input',
    pagePath: '/ssr/old_device_input',
    pageCategory: 'Old Device Input',
  },
  nav_to_country_residence: {
    pageTitle: 'Country Selection',
    pagePath: '/ssr/country',
    pageCategory: 'Country Selection',
  },
  nav_birth_date: {
    pageTitle: 'Date of Birth',
    pagePath: '/ssr/birthdate',
    pageCategory: 'Date of Birth',
  },

  nav_to_code: {
    pageTitle: 'Device Codentify',
    pagePath: '/ssr/codentify',
    pageCategory: 'Device Codentify',
  },
  nav_to_your_devices: {
    pageTitle: 'Device Summary',
    pagePath: '/ssr/device_summary',
    pageCategory: 'Device Summary',
  },

  nav_to_final_page: {
    pageTitle: 'Registration Confirmation',
    pagePath: '/ssr/confirmation',
    pageCategory: 'Registration Confirmation',
  },
  nav_to_number: {
    pageTitle: 'Mobile Phone',
    pagePath: '/ssr/mobile_phone',
    pageCategory: 'Mobile Phone',
  },
  nav_to_phone_code: {
    pageTitle: 'Phone Verification',
    pagePath: '/ssr/verification',
    pageCategory: 'Phone Verification',
  },
  nav_to_first_name: {
    pageTitle: 'Firstname',
    pagePath: '/ssr/firstname',
    pageCategory: 'Firstname',
  },
  nav_to_last_name: {
    pageTitle: 'Lastname',
    pagePath: '/ssr/lastname',
    pageCategory: 'Lastname',
  },
  nav_to_email: {
    pageTitle: 'Email',
    pagePath: '/ssr/email',
    pageCategory: 'Email',
  },
  nav_to_zip_code: {
    pageTitle: 'Zip Code',
    pagePath: '/ssr/zipcode',
    pageCategory: 'Zip Code',
  },
};

const initializeGTM = () => {
  GTM_IDS.forEach((gtmId) => {
    TagManager.initialize({ gtmId });
  });
};
const sendEventToGTM = (eventName) => {
  GTM_IDS.forEach((gtmId) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      gtmId,
    });
  });
};
// Create the context
const DataContext1 = createContext();
const steps = 10;

// Create a provider component
const DataContext1Provider = ({ children }) => {
  const { setFlowNumber } = useFlow();
  useEffect(() => {
    setFlowNumber(1);
  }, []);
  const [gtmReady, setGTMReady] = useState(false);
  const [eventQueue, setEventQueue] = useState([]);

  const [searchParams] = useSearchParams();

  const [journeyData, setJourneyData] = useState({
    journey_id: uuidv4(),
    date: new Date(),
    Landing_page_visit: 0,
    language_change: 0,
    nav_to_country_residence: 0,
    nav_to_coupon: 0,
  nav_to_old_device: 0,
    nav_birth_date: 0,
    nav_to_terms: 0,
    nav_to_code: 0,
    nav_to_your_devices: 0,
    nav_to_another_code: 0,
    nav_to_final_page: 0,
    nav_to_number: 0,
    nav_to_phone_code: 0,
    nav_to_first_name: 0,
    nav_to_last_name: 0,
    nav_to_email: 0,
    nav_to_zip_code: 0,
    error_device_already_registered: 0,
    error_code_not_read: 0,
    device_added: 0,
    nav_to_coupon:0,
  nav_to_old_device:0
  });

  // Initialize GTM and set gtmReady when confirmed
  useEffect(() => {
    initializeGTM();

    const interval = setInterval(() => {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        setGTMReady(true);
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);
  // Drain event queue once GTM is ready
  useEffect(() => {
    if (gtmReady && eventQueue.length) {
      eventQueue.forEach((event) => sendEventToGTM(event));
      setEventQueue([]);
    }
  }, [gtmReady, eventQueue]);
  const track = (v) => {
    if (Object.keys(v)?.length && eventPages[Object.keys(v)[0]]?.pageTitle) {
      GTM_IDS.forEach((gtmId) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'virtualPageView',
virtualPageTittle: eventPages[Object.keys(v)[0]]?.pageTitle, // Please use value referred below
          virtualPageTitle: eventPages[Object.keys(v)[0]]?.pageTitle, // Please use value referred below          virtualPagePath: eventPages[Object.keys(v)[0]]?.pagePath, // Please use value referred below
          virtualPageBrand: 'iqos',
          page: {
            pageInfo: {
              pageName: eventPages[Object.keys(v)[0]]?.pageTitle, // Please use value referred below
              flow:'REGISTRATION',
            },
            category: {
              primaryCategory: 'LUX SSR',
            },
            attributes: {
              language: i18n.language,
              country: 'LU',
              currency: 'EUR',
            },
          },
          gtmId,
        });
      });
    }
    if (Object.keys(v)?.length && Object.keys(v)[0] === 'device_added') {
      GTM_IDS.forEach((gtmId) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'deviceAction',
          deviceAction: 'Add',
          deviceCount: data?.devices?.length || 1, // Updated count of the total number of device of the user
          gtmId,
        });
      });
    }

    if (Object.keys(v)?.length && Object.values(v)[0] !== 0) {
      sendEventToGTM(Object.keys(v)[0]);
    }
    setJourneyData({ ...journeyData, lastUpdatedAt: new Date(), ...v });
  };
  /* eslint-disable react-hooks/exhaustive-deps */

  const trackEvent = useCallback((v) => {
    track(v);
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */
 let initialDate = new Date('1980-06-15');
   const parsed = JSON.parse(localStorage.getItem('ageConfirmation') || '{}');
      const { day, month, year } = parsed;

      if (day && month && year) {
        initialDate = new Date(Number(year), Number(month) - 1, Number(day));
      }
  const [data, setData] = useState({
    country: 'luxembourg',
    uuid: uuidv4(),
    phonenumber: '+352',
    smsConfirmationCode: '',
    zip: '',
    firstname: '',
    lastname: '',
    dob: initialDate,
    email: '',
    agreements: [false, false, false],
    isCodeDisabled: false,
    code: '',
    src: '',
    isCompliant: '',
    isReturning: false,
    shopId: searchParams.get('id')?.length
      ? searchParams.get('id')
      : localStorage.getItem('shopId'),
    smsCodeSentCount: 0,
    storeHasCouponlogic: doesStoreHasCouponlogic(
      searchParams.get('id')?.length
        ? searchParams.get('id')
        : localStorage.getItem('shopId')
    ),
  });

  const [previewSource, setPreviewSource] = useState('');
  const [originalImage, setOriginalImage] = useState('');
  const [file, setFile] = useState();
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [uploadError, setUploadError] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);

  const [currentStep, setCurrentStep] = useState(0);

  const previewFile = async (f) => {
    setUploadLoading(true);
    try {
      setUploadError(false);
      setFile(f);
      const reader = new FileReader();
      reader.readAsDataURL(f);
      reader.onloadend = () => {
        setPreviewSource(reader.result);
        setOriginalImage(reader.result);
      };
    } catch (err) {
      setUploadError(true);
    } finally {
      setUploadLoading(false);
    }
  };
  return (
    <DataContext1.Provider
      value={{
        previewSource,
        originalImage,
        file,
        isViewerOpen,
        setIsViewerOpen,
        steps,
        currentStep,
        setCurrentStep,
        data,
        setData,
        trackEvent,
        gtmReady,
      }}
    >
      <Wrapper>
        <ImageViewer
          src={isViewerOpen}
          closeOnClickOutside={true}
          onClose={() => {
            setIsViewerOpen(false);
          }}
        />
        <input
          type="file"
          id="file-upload-input"
          accept="image/*"
          style={{ display: 'none', opacity: '0' }}
          onChange={(e) => {
            previewFile(e.target.files[0]);
          }}
        />
        {uploadLoading ? (
          <LoadingPage />
        ) : uploadError ? (
          <ErrorPage />
        ) : (
          children
        )}
      </Wrapper>
    </DataContext1.Provider>
  );
};

export { DataContext1, DataContext1Provider };
